import { ArrowUpRight, MapPin, CalendarClock, Banknote } from "lucide-react";

const catColor = {
  Grant: "bg-pink text-black",
  Job: "bg-black text-white",
  Residency: "bg-white text-black border-2 border-black",
  "Open Call": "bg-black text-white",
};

export const OpportunityCard = ({ opp }) => {
  return (
    <article
      data-testid={`opp-card-${opp.id}`}
      className="bg-white brutal-border brutal-shadow brutal-hover p-6 flex flex-col h-full"
    >
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <span className={`label-caps px-2 py-1 ${catColor[opp.category] || "bg-black text-white"}`}>
          {opp.category}
        </span>
        {opp.discipline && (
          <span data-testid={`discipline-${opp.discipline}`} className="label-caps px-2 py-1 bg-white text-black border-2 border-black">
            {opp.discipline}
          </span>
        )}
        {(opp.focus_tags || []).filter((t) => t !== "All").map((t) => (
          <span key={t} data-testid={`tag-${t}`} className="label-caps px-2 py-1 bg-pink text-black">
            {t}
          </span>
        ))}
      </div>

      <h3 className="font-display font-bold text-xl leading-tight mb-1">{opp.title}</h3>
      <p className="label-caps text-black/60 mb-3">{opp.organization}</p>

      <p className="text-sm leading-relaxed text-black/80 mb-5 line-clamp-4">{opp.description}</p>

      <div className="mt-auto space-y-1.5 text-sm">
        <div className="flex items-center gap-2"><CalendarClock size={15} className="text-pink" /><span className="font-semibold">{opp.deadline}</span></div>
        <div className="flex items-center gap-2"><MapPin size={15} className="text-pink" /><span>{opp.location}</span></div>
        {opp.amount && <div className="flex items-center gap-2"><Banknote size={15} className="text-pink" /><span>{opp.amount}</span></div>}
      </div>

      <a
        href={opp.url || "#"}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`apply-btn-${opp.id}`}
        className="mt-5 inline-flex items-center justify-center gap-2 label-caps bg-black text-white py-3 hover:bg-pink hover:text-black transition-colors"
      >
        Apply / Learn More <ArrowUpRight size={16} />
      </a>
    </article>
  );
};
